/* eslint-disable no-console */
import {Col, Form, Row, Select} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React, {useEffect, useState} from 'react';

import {yearKeyLabel} from '../../../../components/Forms/Constants/IP/commonKeyLabel';
import {filterSelectOptions} from '../../../../components/Forms/Utils/commonFunctions';
import {CommonErrors} from '../../../../constants/Common';
import country from '../../../../services/modules/JSON/country';
import useJSONStore from '../../../../store/StaticJson/jsonStore';
import {yearSelect} from '../../../../utils/FormUtils/yearSelect';
import {rowGutter} from '../../../configurator/orgFacility/Constants/Common';
import {financialYearDropdown} from '../../../configurator/orgFacility/orgInfo/constants/commonConstants';
import {
  OPKey,
  OPLabel
} from '../../../configurator/orgFacility/orgInfo/constants/orgProfileKeyLabel';

const CompanyDetailForm: React.FC = () => {
  const form = useFormInstance();
  const {getFieldValue, setFields} = form;
  const {category, subCategory} = useJSONStore.getState();
  const countryOptions = useJSONStore((state) => state.country);
  const [categorySelected, setCategorySelected] = useState<number>(
    getFieldValue(['company', OPKey.CATEGORY])
  );

  useEffect(() => {
    Promise.all([country()])
      .catch(() => {})
      .finally(() => {});
  }, []);

  const colSpan = 24;

  return (
    <>
      <Row
        gutter={rowGutter}
        style={{padding: '5px 0px', margin: 0, rowGap: 0}}
      >
        <Col className="gutter-row" span={colSpan}>
          <Form.Item
            name={['company', OPKey.COMPANY_COUNTRY]}
            label={OPLabel.REGISTERED_BUSINESS_COUNTRY}
            rules={[
              {
                required: true,
                message: CommonErrors.mandatory(
                  OPLabel.REGISTERED_BUSINESS_COUNTRY
                )
              }
            ]}
            validateFirst={true}
            hasFeedback
          >
            <Select
              placeholder={`Choose ${OPLabel.REGISTERED_BUSINESS_COUNTRY}`}
              options={countryOptions}
              showSearch
              filterOption={filterSelectOptions}
            />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={24}>
          <Form.Item
            name={['company', OPKey.FINANCIAL_YEAR_TYPE]}
            label={OPLabel.FINANCIAL_YEAR_TYPE}
            rules={[
              {
                required: true,
                message: CommonErrors.mandatory(OPLabel.FINANCIAL_YEAR_TYPE)
              }
            ]}
            validateFirst={true}
            hasFeedback
          >
            <Select
              placeholder={`Choose ${OPLabel.FINANCIAL_YEAR_TYPE}`}
              options={financialYearDropdown}
              showSearch
              filterOption={filterSelectOptions}
              onChange={(e) => {
                const year = yearSelect(e)?.[0]?.value;
                form.setFieldValue(['facilities', yearKeyLabel.key], year);
              }}
            />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={colSpan}>
          <Form.Item
            name={['company', OPKey.CATEGORY]}
            label={OPLabel.INDUSTRY_CATEGORY}
            rules={[
              {
                required: true,
                message: CommonErrors.mandatory(OPLabel.INDUSTRY_CATEGORY)
              }
            ]}
            validateFirst={true}
            hasFeedback
          >
            <Select
              placeholder={`Choose ${OPLabel.INDUSTRY_CATEGORY}`}
              options={category}
              showSearch
              filterOption={filterSelectOptions}
              onChange={(e) => {
                setCategorySelected(e);

                form.setFieldsValue({
                  company: {
                    [OPKey.CATEGORY]: e,
                    [OPKey.SUB_CATEGORY]: undefined
                  }
                });

                setFields([
                  {
                    name: ['company', OPKey.SUB_CATEGORY],
                    errors: undefined
                  }
                ]);
              }}
            />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={colSpan}>
          <Form.Item dependencies={['company', OPKey.CATEGORY]}>
            {({getFieldValue}) => {
              return (
                <Form.Item
                  key={categorySelected}
                  name={['company', OPKey.SUB_CATEGORY]}
                  label={OPLabel.INDUSTRY_SUB_CATEGORY}
                  rules={[
                    {
                      required: true,
                      message: CommonErrors.mandatory(
                        OPLabel.INDUSTRY_SUB_CATEGORY
                      )
                    }
                  ]}
                  shouldUpdate
                  validateFirst={true}
                  hasFeedback
                  style={{marginBottom: '0px'}}
                >
                  <Select
                    placeholder={`Choose ${OPLabel.INDUSTRY_SUB_CATEGORY}`}
                    showSearch
                    filterOption={filterSelectOptions}
                    disabled={!getFieldValue(['company', OPKey.CATEGORY])}
                    options={
                      getFieldValue(['company', OPKey.CATEGORY])
                        ? subCategory
                            .filter(
                              (item) =>
                                item?.categoryId ===
                                getFieldValue(['company', OPKey.CATEGORY])
                            )
                            .map((item) => {
                              return {value: item.value, label: item.label};
                            })
                        : [{value: 0, label: ''}]
                    }
                  />
                </Form.Item>
              );
            }}
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default CompanyDetailForm;
